/*
 * -----------------------------------------------------------------------------------------
 * applicationInitializeSaga.ts
 *
 * Copyright: (c) 2004-2020 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 13.10.2020
 * Autor    : Markus Plutka
 *
 * Geändert : 30.09.2021
 *      von : Markus Plutka
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import { put, select } from "redux-saga/effects";

import { initializeFailure, initializeSuccess } from "reducers/application";
import { State } from "reducers/index";

export default function* applicationInitializeSaga() {
    const { error } = yield select((state: State) => state.application);

    if (error) {
        yield put(initializeFailure(error));
        return;
    }
    yield put(initializeSuccess());
}
